export const handleMenuModalClose = (): void => {
  const menuElement = document.getElementById('popup-root')?.children[1] as HTMLElement
  if (menuElement) {
    menuElement.style.visibility = 'hidden'
  }
}
